import React from 'react';
import PressMedia from 'templates/pressMedia';

const Press = () => (
  <PressMedia />
);

export default Press;
